// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"167":"8d56625f","450":"fa84ea86","455":"492e6b75","977":"4b3215a8"}[chunkId] + ".chunk.js";
};